export const getSchemaOrgWebPage = ({ seo, defaultAuthor, buildTime }) => ({
  '@context': 'http://schema.org',
  '@type': 'WebPage',
  url: seo.url,
  headline: seo.title,
  inLanguage: seo.lang,
  mainEntityOfPage: seo.defaultUrl,
  description: seo.description,
  name: seo.title,
  author: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  copyrightHolder: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  copyrightYear: '2021',
  creator: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  publisher: {
    '@type': 'Person',
    name: defaultAuthor,
  },
  datePublished: '2021-07-09T09:30:00+01:00',
  dateModified: buildTime,
  image: {
    '@type': 'ImageObject',
    url: seo.image,
  },
});
